import { Component } from '@angular/core';
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { AdalHttp } from '../../services/adal.http.service';
import Adminpermissionsdetails = require("./admin-permissions-details");

@
Component({
    selector: 'portaladmin-service'
})

export class PortalAdminService {
    constructor(private http: AdalHttp) {
    }

    getAllPermissions(userLiveId: string): Observable<any>{
        let productUrl: string = "/api/portal/admin/users/"+userLiveId;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error || "server error");
            });
    }
    savePermissions(userLiveId: string, permissions: Array<Adminpermissionsdetails.AdminPermissions>):
        Observable<any> {
        let productUrl: string ="/api/portal/admin/users/" + userLiveId;
        return this.http.post(productUrl, permissions).catch((error: any) => {
            return Observable.throw(error || "server error");
        });
    }

    getUserObjectId(userLiveId: string): Observable<any> {
        let url: string = `/api/portal/admin/users/${userLiveId}/resolve`;
        return this.http.get(url)
            .catch((error: any) => {
            return Observable.throw(error || "server error");
        });
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/portalAdmin/portaladmin.service.ts
 **/